var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyLearnings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 106,
    viewBox: "0 0 197 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169.173 99.7014C169.173 102.453 166.967 104.687 164.228 104.733H164.142L26.1387 104.744C23.3588 104.744 21.1066 102.492 21.1045 99.7122L21.0908 5.6604L169.159 5.64966L169.173 99.7014Z",
    fill: "white",
    stroke: "#D2DCF1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.0811,
    y: 21.3044,
    width: 53,
    height: 16,
    rx: 2,
    fill: "#E7EFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 100.081,
    y: 21.3044,
    width: 53,
    height: 16,
    rx: 2,
    fill: "#E7EFFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37.0811,
    y: 47.3044,
    width: 53,
    height: 16,
    rx: 2,
    fill: "#E7EFFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 37.0811,
    y: 73.3044,
    width: 53,
    height: 16,
    rx: 2,
    fill: "#E7EFFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 100.081,
    y: 47.3044,
    width: 53,
    height: 16,
    rx: 2,
    fill: "#E7EFFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 100.081,
    y: 73.3044,
    width: 53,
    height: 16,
    rx: 2,
    fill: "#E7EFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.207 72.9183C151.541 73.145 153.32 74.5007 153.181 75.9489C153.04 77.3972 151.034 78.3873 148.7 78.1606C146.366 77.9339 144.584 76.5782 144.726 75.13C144.867 73.6818 146.873 72.6916 149.207 72.9183Z",
    fill: "#41536D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.843 77.1472L146.208 73.3669",
    stroke: "#4A5059",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M145.64 75.2201C145.691 74.6903 145.881 74.2068 146.165 73.7996C145.934 73.6377 145.663 73.5243 145.363 73.4966C144.435 73.4063 143.609 74.0865 143.519 75.0142C143.429 75.9419 144.109 76.7678 145.036 76.858C145.337 76.8881 145.624 76.8279 145.883 76.7146C145.682 76.2611 145.587 75.7499 145.64 75.2201Z",
    fill: "#41536D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148.827 70.1236C151.032 68.9738 153.246 68.8558 153.771 69.8645C154.296 70.8732 152.936 72.6222 150.731 73.7719C148.527 74.9217 146.313 75.0397 145.787 74.0311C145.262 73.0224 146.623 71.2734 148.827 70.1236Z",
    fill: "#AFEFDD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.42 69.3579C149.141 67.5626 151.203 66.746 152.024 67.5325C152.845 68.3191 152.114 70.4128 150.393 72.2081C148.672 74.0033 146.611 74.82 145.789 74.0334C144.968 73.2468 145.699 71.1531 147.42 69.3579Z",
    fill: "#42CC97"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M147.788 80.8329C149.732 82.3852 151.881 82.9243 152.591 82.0359C153.301 81.1475 152.302 79.1695 150.359 77.6172C148.415 76.0648 146.266 75.5258 145.556 76.4142C144.846 77.3025 145.845 79.2805 147.788 80.8329Z",
    fill: "#AFEFDD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M146.261 81.3139C147.607 83.4053 149.472 84.6036 150.428 83.9883C151.383 83.3729 151.068 81.1797 149.722 79.086C148.376 76.9946 146.511 75.7963 145.555 76.4117C144.6 77.027 144.915 79.2202 146.261 81.3139Z",
    fill: "#42CC97"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M142.892 76.3516L143.701 75.9514",
    stroke: "#4A5059",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M143.159 73.5798L143.879 74.1304",
    stroke: "#4A5059",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M172.878 0.742573C181.986 -0.825957 191.814 4.9045 194.916 13.6101C198.016 22.3156 194.01 32.983 185.931 37.4735C184.996 37.994 183.981 38.4451 182.912 38.4474C180.076 38.4544 178.123 34.8755 179.243 32.2682C180.362 29.6609 183.694 28.4741 186.424 29.2468C189.154 30.0195 191.226 32.3677 192.305 34.9911C194.655 40.7054 192.788 47.3358 189.709 52.6938C182.375 65.4572 168.582 73.2859 153.903 75.4907",
    stroke: "#A6B1C0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8105 12.6059C10.3525 14.3595 9.1009 15.5533 8.01357 15.2687C6.92624 14.9865 6.41496 13.3347 6.87072 11.5788C7.32878 9.82515 8.58037 8.63141 9.6677 8.91596C10.755 9.20052 11.2663 10.85 10.8105 12.6059Z",
    fill: "#41536D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99316 9.52222L10.8341 10.2625",
    stroke: "#4A5059",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48927 9.60289C9.88719 9.707 10.2319 9.91059 10.5095 10.1766C10.6622 10.0193 10.7802 9.8273 10.838 9.60058C11.0208 8.90423 10.602 8.18937 9.90338 8.00892C9.20703 7.82615 8.49217 8.24489 8.31172 8.94356C8.25388 9.17028 8.26313 9.39468 8.31866 9.60752C8.68881 9.50804 9.09135 9.49879 9.48927 9.60289Z",
    fill: "#41536D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9893 12.6545C13.5977 14.4775 13.4173 16.1802 12.5844 16.4602C11.7516 16.7378 10.5809 15.4862 9.9725 13.6655C9.36406 11.8425 9.54451 10.1398 10.3774 9.85984C11.2102 9.58222 12.3808 10.8338 12.9893 12.6545Z",
    fill: "#AFEFDD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7452 11.6735C14.9042 13.2051 15.2767 14.8777 14.578 15.4075C13.8794 15.9373 12.3687 15.1252 11.2096 13.5937C10.0506 12.0622 9.67811 10.3896 10.3768 9.85978C11.0778 9.33 12.5861 10.142 13.7452 11.6735Z",
    fill: "#42CC97"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94502 10.5585C3.52455 11.8517 2.85133 13.4272 3.44127 14.0773C4.03352 14.7274 5.66451 14.2045 7.08498 12.9113C8.50545 11.6181 9.17866 10.0426 8.58873 9.39251C7.9988 8.74242 6.36549 9.26527 4.94502 10.5585Z",
    fill: "#AFEFDD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7629 9.33484C3.00235 10.1075 1.86181 11.3846 2.21578 12.1897C2.56742 12.9947 4.2817 13.0202 6.04225 12.2498C7.8028 11.4771 8.94333 10.2001 8.58937 9.39499C8.23541 8.58991 6.52345 8.56446 4.7629 9.33484Z",
    fill: "#42CC97"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95996 7.36597L9.16817 8.03456",
    stroke: "#4A5059",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0408 7.90942L10.5342 8.39063",
    stroke: "#4A5059",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36919 16.7957C7.29516 16.9298 7.22113 17.064 7.14941 17.2028",
    stroke: "#4A5059",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74081 18.0242C3.3539 25.1612 2.838 35.8263 11.9623 38.6001C14.2873 39.3057 16.8692 39.1369 18.8333 37.5984C22.1739 34.9819 20.9293 29.9987 17.3851 28.2242C11.421 25.2376 5.3134 32.6083 3.1133 37.3115C-6.64722 58.1698 12.4319 85.6584 33.4984 90.3825",
    stroke: "#A6B1C0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.98 3.98"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9502 90.4792C34.1006 90.5116 34.2533 90.5417 34.4036 90.5695",
    stroke: "#4A5059",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyLearnings);
export default __webpack_public_path__ + "static/media/emptyLearnings.88537cc461ea81ffa237f30b73c3e7b6.svg";
export { ForwardRef as ReactComponent };